import { Alert } from '@mui/material';
import { RiskTierFormRow } from './RiskTierRow';
import {
  greenPairHasNoThreshold,
  hasNonSequentialThresholds,
  hasNoPastTier,
  onTrackWindowDays,
  onTrackWindowWarning,
  sameDateWarning,
  tierName,
  unavailableDateWarning,
  unthresholdedPairWarning
} from './riskTierPresentation';

export interface RiskTierNoticesProps {
  rows: RiskTierFormRow[];
  selfMeasuringTiers: string[];
  unmeasuredTiers: string[];
  // False while the catalogue is empty, when no replacement date can be offered.
  canReplaceDates: boolean;
  unavailableBlocksSave: boolean;
}

export const RiskTierNotices = ({
  rows,
  selfMeasuringTiers,
  unmeasuredTiers,
  canReplaceDates,
  unavailableBlocksSave
}: RiskTierNoticesProps) => {
  const fallbackTier = rows.find((row) => row.tier === 'green');
  const windowDays = onTrackWindowDays(rows);

  return (
    <>
      {selfMeasuringTiers.length > 0 && (
        <Alert
          severity="error"
          className="mt-4"
          data-cy="risk-same-date-warning"
          data-testid="risk-same-date-warning">
          {sameDateWarning(selfMeasuringTiers)}
        </Alert>
      )}
      {unmeasuredTiers.length > 0 && (
        <Alert
          severity="warning"
          className="mt-4"
          data-cy="risk-date-unavailable-warning"
          data-testid="risk-date-unavailable-warning">
          {unavailableDateWarning(unmeasuredTiers, {
            canReplace: canReplaceDates,
            blocksSave: unavailableBlocksSave
          })}
        </Alert>
      )}
      {hasNoPastTier(rows) && (
        <Alert
          severity="warning"
          className="mt-4"
          data-cy="risk-no-past-tier-warning"
          data-testid="risk-no-past-tier-warning">
          No tier is measured Past its comparison date, so a service running late is left with no risk mark at all. Set
          Past or Before to Past on at least one tier to flag late services.
        </Alert>
      )}
      {fallbackTier && greenPairHasNoThreshold(rows) && (
        <Alert
          severity="warning"
          className="mt-4"
          data-cy="risk-unthresholded-pair-warning"
          data-testid="risk-unthresholded-pair-warning">
          {unthresholdedPairWarning(tierName(fallbackTier))}
        </Alert>
      )}
      {fallbackTier && windowDays !== null && (
        <Alert
          severity="warning"
          className="mt-4"
          data-cy="risk-on-track-window-warning"
          data-testid="risk-on-track-window-warning">
          {onTrackWindowWarning(tierName(fallbackTier), windowDays)}
        </Alert>
      )}
      {hasNonSequentialThresholds(rows) && (
        <Alert
          severity="warning"
          className="mt-4"
          data-cy="risk-threshold-gap-warning"
          data-testid="risk-threshold-gap-warning">
          Day Thresholds are not sequential. Please adjust so that there are no gaps between Day Thresholds.
        </Alert>
      )}
    </>
  );
};
